import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components/index"
import linkHandler from "../../helpers/storyblokLinkHandler"
import * as Icon from "react-feather"

const CrumbTrail = ({ blok }) => (
  <SbEditable content={blok}>
    <div className="crumb-trail">
      <div className="container">
        <div className="crumb-trail__group">
          <a
            href={linkHandler(blok.parent_site_url)}
            className="crumb-trail__group-item"
          >
            <div className="crumb-trail__image">
              {blok.crumb_image &&
                blok.crumb_image.map(
                  content =>
                    React.createElement(Components(content.component), {
                      key: content._uid,
                      blok: content,
                    })
                )}
            </div>
            <div className="crumb-trail__label">{blok.parent_site}&nbsp;</div>
          </a>
          <div className="crumb-trail__group-item crumb-trail__group-item--current">
            <div className="crumb-trail__label">/&nbsp;{blok.current_site}</div>
          </div>
        </div>
      </div>
    </div>
  </SbEditable>
)

CrumbTrail.propTypes = {
  blok: PropTypes.shape({
    crumb_image: PropTypes.arrayOf(PropTypes.object),
    parent_site: PropTypes.string,
    parent_site_url: PropTypes.shape({
      linktype: PropTypes.string,
      cached_url: PropTypes.string,
      url: PropTypes.string,
    }),
    current_site: PropTypes.string,
  }).isRequired,
}

export default CrumbTrail
